import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Heart } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

export default function StickyDonate() {
    const { t } = useLang();
    const [visible, setVisible] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 600);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    if (location.pathname === "/donate") return null;

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ opacity: 0, y: 30, scale: 0.9 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: 30, scale: 0.9 }}
                    transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                    className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-40"
                >
                    <Link to="/donate" data-testid="sticky-donate-cta">
                        <motion.button
                            whileHover={{ scale: 1.06 }}
                            whileTap={{ scale: 0.97 }}
                            className="group inline-flex items-center gap-2 rounded-full bg-caireen-red text-white font-sans font-bold px-6 py-4 shadow-[0_18px_36px_-12px_rgba(217,53,44,0.55)] ring-2 ring-white/50"
                        >
                            <span className="relative flex w-3 h-3">
                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-50" />
                                <span className="relative inline-flex rounded-full h-3 w-3 bg-white" />
                            </span>
                            <Heart className="w-4 h-4" strokeWidth={2.4} fill="currentColor" />
                            {t.nav.donateCta}
                        </motion.button>
                    </Link>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
